var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgModalityDark = function SvgModalityDark(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    fill: "rgba(255, 255, 255, 0.7)",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 32 32",
    style: {
      msTransform: "rotate(360deg)",
      WebkitTransform: "rotate(360deg)",
      transform: "rotate(360deg)"
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 32h7v-7h-2v5h-5v2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 27h-3V17h3a3.003 3.003 0 0 1 3 3v4a3.003 3.003 0 0 1-3 3zm-1-2h1a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 27h-6v-4a2.002 2.002 0 0 1 2-2h2v-2h-4v-2h4a2.002 2.002 0 0 1 2 2v2a2.002 2.002 0 0 1-2 2h-2v2h4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 15h-3V5h3a3.003 3.003 0 0 1 3 3v4a3.003 3.003 0 0 1-3 3zm-1-2h1a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5h-4v2h4v2h-3v2h3v2h-4v2h4a2.003 2.003 0 0 0 2-2V7a2.002 2.002 0 0 0-2-2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 27H8v-3.046c-4.715-.442-6-4.01-6-5.954c0-3.015 2.082-4.502 3.919-5.814C7.572 11.006 9 9.986 9 8V5h2v3c0 3.015-2.082 4.502-3.919 5.814C5.428 14.994 4 16.014 4 18c.005.403.191 4 5 4a1 1 0 0 1 1 1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7 0H0v7h2V2h5V0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    fill: "rgba(0, 0, 0, 0)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgModalityDark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ModalityDark.b0d19d7fbc230597472da07db5324084.svg";